import {useState, useEffect, useRef} from "react";
import { useToast } from "../../../components/notificaciones/ToastProvider";
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import PeriodoDeContratacion from "../../../components/catalogo/PeriodoDeContratacion";
import { useFormik, FormikProvider } from "formik";
import Banco from "../../../components/catalogo/Banco";
import Tarjeta from "../../../components/catalogo/Tarjeta";
import Cajas from "../../../components/catalogo/Cajas";
import { validacionPago } from "../Validaciones/ValidacionDatos";
import ErrorMessage from "../../../components/helpers/ErrorMessage";
import { axiosInstance } from "../../../components/helpers/axiosInstance";
import { useContratos } from "../../../components/contratos/ContratosProvider";
import { CustomProvider } from "rsuite";
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css'
import * as locales from 'rsuite/locales';
import {isAfter} from "date-fns";
import CardCliente from "../../../components/helpers/CardCliente";


const datePago = new Date();
/**
 * @function valorInicial Devuelve valores iniciales con sus respectivos atributos de cada metodo de pago
 * @param tipo
 * @param contrato
 * @returns {{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number}|{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number, sucursal: string}|{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number, tarjeta: string}|{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number, autorizacion: string, referencia: string}|{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number, autorizacion: string}|{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: *, total: *, forma_pago: string, id_caja: number, concepto: string, cuentahabiente: string}}
 */
function valorInicial(tipo,contrato) {
    /**
     * Fecha del día actual
     * @type {string}
     */
    const today = dayjs().format('YYYY-MM-DD');
    /**
     * Vigencia del contrato
     * @type {string}
     */
    let corte = dayjs(contrato.hasta).format('YYYY-MM-DD');
    /**
     * Variable para guardar el inicio del contrato
     */
    let inicio;
    /**
     * Mes actual
     * @type {number}
     */
    const month = dayjs().get('month');
    /**
     * Año actual
     * @type {number}
     */
    const year = dayjs().get('year');
    /**
     * Dependiendo si es un pago adelantado o atrasado cambia su fecha de inicio
     */
    if (corte > today){
        /**
         * Sí es un pago adelantado su fecha de inicio seria un día después del vencimiento
         * @type {string}
         */
        inicio = dayjs(contrato.hasta).add(1, 'days').format('YYYY-MM-DD');
        //corte = dayjs(contrato.hasta).add(1, 'days').format('YYYY-MM-DD');
    } else {
        /**
         * En caso contrario; sí el corte es los días 30 su fecha de corte sería a finales del mes actual
         * y en quincenales el 15 de ese mes.
         */
        corte = Number(contrato.corte) === 30 ? ( dayjs().endOf('month').format('YYYY-MM-DD') ) : ( dayjs().set('date', 15).format('YYYY-MM-DD') );
        /**
         * Sí aún no pasa la nueva fecha de corte su inicio ser calcula como cuando se da de alta un contrato,
         * sí ya paso la fecha de inicio es la misma fecha de corte
         */
        if (today < corte){
            inicio = Number(contrato.corte) === 30 ? (dayjs(corte).startOf('month').format('YYYY-MM-DD')) : (dayjs(corte).subtract(1, 'month').format('YYYY-MM-DD'))
            // corte = dayjs(corte).subtract(1, 'month').format('YYYY-MM-DD');
        } else {
            inicio = Number(contrato.corte) === 30 ? ( dayjs(`${year}-${Number(month+2)}-01`).format('YYYY-MM-DD') ) : ( corte );
        }
    }

    /**
     * Corte de servicio
     * @type {string}
     */
    const fin = dayjs(inicio).add(1, 'months').subtract(1, "day").format('YYYY-MM-DD');

    /**
     * Atributos generales del formulario
     * @type {{contratacion: string, desde: string, hasta: string, observaciones: string, cupon: string, factura: boolean, ajuste: string, subtotal: string|*|string, total: string|*|string}}
     */
    const initial = {
        contratacion : "Mensual",
        desde : inicio,
        hasta : fin,
        observaciones : "",
        cupon: "",
        factura : false,
        ajuste : "",
        subtotal : contrato.costo,
        total : contrato.costo,
        fecha_pago : datePago,
    }
    /**
     * Cambia dependiendo el tipo de pago
     */
    switch (tipo) {
        case "TR":
            return {
                ...initial,
                forma_pago : "TR",
                id_caja : 1,
                concepto : "",
                cuentahabiente : "",
            };
        case "DE":
            return {
                ...initial,
                forma_pago : "DE",
                id_caja : 1,
                autorizacion : "",
                referencia : ""
            };
        case "EF":
            return {
                ...initial,
                forma_pago : "EF",
                id_caja : 100 //valor de inicio de sesión
            };
        case "CO":
            return {
                ...initial,
                forma_pago : "CO",
                id_caja : 2,
                autorizacion : "",
            };
        case "TE":
            return {
                ...initial,
                forma_pago : "TE",
                id_caja : 1,
                tarjeta : "D",
            };
        default:
            return {
                ...initial,
                forma_pago : "CH",
                id_caja : 1,
                sucursal : "",
            };
    }
}
/**
 * COMPONENTE PRINCIPAL
 * @param contrato ( información de contrato )
 * @param typeB
 * @returns {JSX.Element}
 * @constructor
 */
export default function RegistrarPago({
  contrato,
    typeB
}) {
    const [show, setShow] = useState(false);
    /**
     * Controlar pasos de pago
     */
    const [step, setStep] = useState(0);
    /**
     * Guardar tipo de pago
     */
    const [select, setSelect] = useState({
        valor : 'TR',
        descripcion: "Transferencia",
    });
    /**
     * Notíficaciones
     * @type {undefined}
     * @property setArrayToast
     */
    const toastP = useToast();
    /**
     * Contexto : usar función handleChangeState
     * @function handleChangeState cambiar datos en Storage y la nueva fecha de vencimiento
     */
    const { handleChangeState } = useContratos();

    /**
     * @function onSubmit Envío de datos al servidor
     * @param values
     */
    function onSubmit(values) {

        values.fecha_pago = dayjs(values.fecha_pago).format('YYYY-MM-DD');

        axiosInstance.post('/clientes/'+contrato.id_cliente+'/contratos/' + contrato.id_contrato + '/pagos', values)
            .then((response) => {
                if (response.status === 200 && typeof response.data === 'object' && response.data !== null) {
                    /**
                     * Notificación : el registro fue exitoso
                     */
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id : contrato.id_contrato,
                                text: "Pago del cliente " + contrato.cliente.cliente +" registrado",
                                color: 'success',
                                show: true
                            }
                        ]
                    );
                    /**
                     * Cambiar los nuevos datos del contrato
                     */
                    handleChangeState( Number(contrato.id_contrato), 1, response.data.fecha, response.data.hasta, 1);
                    handleClose();
                } else {
                    toastP.setArrayToast(
                        prevToasts => [
                            ...prevToasts,
                            {
                                id : contrato.id_contrato,
                                text: "No se pudo procesar el pago, intente más tarde",
                                color: 'danger',
                                show: true
                            }
                        ]
                    );
                }
            }).catch((error) => {
            /**
             * Notificación : hubo error en la petición
             */
            toastP.setArrayToast(
                prevToasts => [
                    ...prevToasts,
                    {
                        id : contrato.id_contrato,
                        text: "Hubo un error en los datos: " + error.response.data.errors[0].message,
                        color: 'danger',
                        show: true
                    }
                ]
            );
        })
    }
    /**
     * @const formik manejo de formulario
     */
    const formik = useFormik({
        initialValues : valorInicial(select.valor,contrato),
        validationSchema : validacionPago(select.valor)[step],
        enableReinitialize : true,
        onSubmit
    });
    /**
     * Validar formulario desde que se carga el componente
     */
    const { validateForm } = formik;

    useEffect(() => {
        void validateForm();//.then(data => data);
    }, [step, validateForm]);

    /**
     * @function handleClose Limpiar valores y estados del formulario ( regresarlos a su valor inicial )
     */
    function handleClose(){
        formik.resetForm();
        setShow(false);
        setStep(0);
        setSelect({
            valor: 'TR',
            descripcion: "Transferencia",
        });
    }


    return(
        <>
            {
                typeB ? (
                    <TitleTooltip title={'Reportar pago'} placement={'bottom'}>
                        <button className={"btn btn-sm btn-icon btn-active-light btn-active-icon-primary me-2"} onClick={() => setShow(true)}>
                            <i className="ki-outline ki-dollar fs-1"></i>
                        </button>
                    </TitleTooltip>
                ) : (
                    <button className="d-flex btn btn-sm btn-success fw-normal me-3" onClick={() => setShow(true)}>
                        <i className="ki-solid ki-dollar fs-3"></i>
                        <span className={"d-none d-md-flex"}>
                                                                            Reportar Pago
                                                                        </span>
                    </button>
                )
            }

            <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                fullscreen={true}
            >
                <Modal.Header closeButton tabIndex={-1}>
                    <div className="d-flex justify-content-center align-items-center">
                        <i className="bi bi-wallet-fill fs-2qx text-primary"></i>
                        <span className="modal-title h3 ps-2"> Registrar pago </span>
                    </div>
                </Modal.Header>
                <Modal.Body className={"align-content-center p-0"}>
                    <div className={"container d-grid d-md-flex align-items-center justify-content-center"}>
                        <FormPago contrato={contrato} formik={formik} step={step} select={select} setSelect={setSelect}></FormPago>
                    </div>
                </Modal.Body>
                <Modal.Footer className={"d-flex"}>
                    <button type={'button'} className={"btn btn-secondary me-5"} onClick={handleClose}>
                        Cancelar
                    </button>
                    {
                        step > 0 ? (<div className="mr-2">
                            <button type="button" className="btn btn-light-primary me-3"
                                    onClick={() => setStep(step - 1)}
                            >
                                <i className="ki-duotone ki-arrow-left fs-4 rotate-180">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                                Atras
                            </button>
                        </div>) : (<div></div>)
                    }
                    <div>
                        <button form={"registrar-pago"} type={'submit'} className={"btn btn-primary me-3 " + (step < 1 && "d-none" )}
                                disabled={Object.keys(formik.errors).length > 0}
                        >
                            <span className="indicator-label"> Enviar
                                <i className="ki-duotone ki-arrow-right fs-4 ms-2 me-0">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </span>
                        </button>
                        <button type="button" className={"btn btn-primary " + (step === 1 && "d-none")} onClick={() => setStep(step + 1)}
                            //nextStep
                                disabled={Object.keys(formik.errors).length > 0}
                        >
                            Continuar
                            <i className="ki-duotone ki-arrow-right fs-4 ms-1 me-0">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}



function FormPago({
                      contrato,
                      formik,
                      step,
                      select,
                      setSelect
                  }) {
    /**
     * Datos del catálogo : contratación
     */
    const { periocidades } = JSON.parse(localStorage.getItem("catalogosContratos")) ?? [];
    /**
     * Activar ajuste
     */
    const [ switchAjuste, setSwitchAjuste ] = useState(false);
    /**
     * Activar factura
     */
    const [ facSwitch, setFacSwitch ] = useState(0.00);
    /**
     *
     */
    const fechaRef = useRef(null);

    /**
     * Arreglo de formas de pago con icon
     * @type {[{tipo: string, valor: string, icon},{tipo: string, valor: string, icon},{tipo: string, valor: string, icon},{tipo: string, valor: string, icon},{tipo: string, valor: string, icon},null]}
     */
    const formasPago = [
        {
            tipo : "Transferencia",
            valor : "TR",
            icon : <i className="ki-duotone ki-two-credit-cart fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
            </i>
        },
        {
            tipo : "Deposito",
            valor: "DE",
            icon : <i className="ki-duotone ki-save-deposit fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
            </i>
        },
        {
            tipo : "Efectivo",
            valor: "EF",
            icon : <i className="ki-duotone ki-bill fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
                <span className="path6"></span>
            </i>
        },
        {
            tipo: "Conveniencia",
            valor: "CO",
            icon: <i className="ki-duotone ki-shop fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
            </i>
        },
        {
            tipo: "Terminal",
            valor: "TE",
            icon: <i className="ki-duotone ki-finance-calculator fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
                <span className="path6"></span>
                <span className="path7"></span>
            </i>
        },
        {
            tipo : "Cheque",
            valor: "CH",
            icon : <i className="ki-duotone ki-wallet fs-2x me-2 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
            </i>
        }
    ];

    const { setFieldValue, values } = formik;
    /**
     * Desactivar ajuste y factura cuando se cambia de forma de pago
     */
    useEffect(() => {
        setSwitchAjuste(false);
    }, [select]);

    /**
     * @function changePeriodo Cálcular fechas de duración de contrato y costo según el periodo
     * @param periodo
     */
    function changePeriodo(periodo) {
        setFieldValue('contratacion', periodo);
        let num;
        switch (periodo) {
            case "Trimestral":
                num  = 3;
                break;
            case "Bimestral":
                num  = 2;
                break;
            case "Semestral":
                num = 6;
                break;
            case "Anual":
                num = 12;
                break;
            default:
                num = 1;
                break;
        }
        /**
         * Sí el ajuste esta activo el costo no se cálcula
         */
        if (switchAjuste) {
            setFieldValue('hasta', dayjs(values.desde).add(num, 'months').subtract(1, "day").format('YYYY-MM-DD'));
        } else {
            setFieldValue('subtotal', Number(contrato.costo) * num);
            setFieldValue('hasta', dayjs(values.desde).add(num, 'months').subtract(1, "day").format('YYYY-MM-DD'));
        }
    }

    /**
     * Cálcular I.V.A
     */
    useEffect(() => {
        if (values.factura && switchAjuste){
            const cost = (values.ajuste / 1.16);
            const iva = Math.ceil(values.ajuste - cost);
            setFacSwitch(iva);
            setFieldValue('subtotal', Math.ceil(cost));
            setFieldValue('total', values.ajuste);
        } else if (values.factura){
            const iva = values.subtotal * 0.16;
            setFacSwitch(iva);
            const t = Number(values.subtotal) + Number(iva);
            setFieldValue('total', t);
        } else if (switchAjuste){
            setFieldValue('subtotal', values.ajuste);
            setFieldValue('total', values.ajuste);
            setFacSwitch(0);
        }
        else{
            setFieldValue('total', values.subtotal);
            setFacSwitch(0);
        }
    },[setFieldValue, switchAjuste, values.ajuste, values.subtotal, values.factura]);
    /**
     * Ignorar el costo de contrato e ingresar el monto real del pago
     */
    useEffect(() => {
        if (switchAjuste){
            setFieldValue('subtotal', values.ajuste);
            setFieldValue('total', Number(values.ajuste));
        } else {
            setFieldValue('subtotal', contrato.costo);
            setFieldValue('total', Number(contrato.costo));
            setFieldValue('ajuste', "");
        }
    }, [switchAjuste, setFieldValue, values.ajuste, contrato.costo]);
    /**
     * Focus Select contratacion
     */
    useEffect(() => {
        const element = document.getElementById('contratacion');

        if (element && step === 1) {
            element.focus();
        }
    }, [step, setFieldValue, values.fecha_pago]);


    /**
     * @param contrato.corte
     * @param contrato.ultimo_pago
     * @param contrato.costo_paquete
     * @param contrato.costo_addons
     * @param contrato.saldo
     */

    return (
        <>
            <style type={'text/css'}>
                {`
                    .fecha_pago > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #fecha_pago{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                `}
            </style>
            <div className="content d-flex flex-column flex-column-fluid" id="registrar-pago-card">
                <div className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid gap-10" id="kt_create_account_stepper">
                    <div className="card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px" style={{border: "1px solid var(--bs-card-border-color)"}}>
                        <div className="card-body px-6 px-lg-10 px-xxl-15 py-20">
                            <div className="stepper-nav">
                                <div className={"stepper-item " + (step === 0 ? "current" : step > 0 ? "completed" : "")}>
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">1</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Método de pago</h3>
                                            <div className="stepper-desc fw-semibold">{select.descripcion}</div>
                                        </div>
                                    </div>
                                    <div className="stepper-line h-40px"></div>
                                </div>
                                <div className={"stepper-item " + (step === 1 ? "current" : step > 1 ? "completed" : "")}>
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                            <span className="stepper-number">2</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">Datos de comprobante</h3>
                                            <div className="stepper-desc fw-semibold">Información del pago</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card d-flex flex-row-fluid flex-center" style={{border: "1px solid var(--bs-card-border-color)"}}>
                        <div className={"card-body px-9 pt-2"}>
                            <CardCliente contrato={contrato}></CardCliente>
                            <FormikProvider value={formik}>
                                <form id={"registrar-pago"} className="" onSubmit={formik.handleSubmit}>
                                    <div className={step === 0 ? "current" : ""} data-kt-stepper-element="content">
                                        <div className="w-100">
                                            <h2 className="fw-bold" tabIndex={-1}>Forma de pago</h2>
                                            {
                                                formasPago && formasPago.length > 0 && formasPago.map(({tipo,valor , icon}, index) => {
                                                    return (
                                                        <div key={tipo}>
                                                            <div className="d-flex flex-stack flex-wrap">
                                                                <div className="d-flex align-items-center my-3">
                                                                    <div className="d-flex ms-9">
                                                                        <label
                                                                            className="form-check form-check-custom form-check-solid me-5">
                                                                            <input className="form-check-input w-15px h-15px" type="radio"
                                                                                   name="payment_method"
                                                                                   defaultChecked={index === 0}
                                                                                   onChange={() => setSelect({valor : valor, descripcion : tipo})}/>
                                                                        </label>
                                                                    </div>
                                                                    {icon}
                                                                    <div className="me-3">
                                                                        <div className="d-flex align-items-center fs-5 text-uppercase">{tipo}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={"separator separator-dashed " + (index === (formasPago.length - 1) && "d-none")}></div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={step === 1 ? "current" : ""} data-kt-stepper-element="content">
                                        <div className="w-100">
                                            <div className={'row'}>
                                                <div className={"col-md-3"}>
                                                    <div className={"position-relative"} ref={fechaRef}>
                                                        <CustomProvider locale={locales.esES}>
                                                            <DatePicker
                                                                container={() => fechaRef.current}
                                                                className={"fecha_pago"}
                                                                id={"fecha_pago"}
                                                                name={"fecha_pago"}
                                                                style={{width:'100%'}}
                                                                label={<div className={"labelSelect ps-2 pb-4"}>Fecha de pago:</div>}
                                                                oneTap={true}
                                                                cleanable={false}
                                                                format={'MMM. dd, yyyy'}
                                                                value={values.fecha_pago}
                                                                shouldDisableDate={date => isAfter(date, new Date())}
                                                                onChange={value => setFieldValue('fecha_pago', value)}
                                                            >
                                                            </DatePicker>
                                                        </CustomProvider>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <PeriodoDeContratacion formik={formik} data={periocidades} changePeriodo={changePeriodo}></PeriodoDeContratacion>
                                                    <ErrorMessage name={'contratacion'}></ErrorMessage>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-floating mb-7">
                                                        <input type="text"
                                                               className="form-control bg-gray-200 text-gray-700 border-0 text-uppercase"
                                                               id="desde"
                                                               name="desde"
                                                               placeholder="inicio"
                                                               value={dayjs(values.desde).format('MMM. DD, YYYY')}
                                                               disabled={true}
                                                        />
                                                        <label htmlFor="desde" className={"text-gray-700"}>Inicio</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-floating mb-7">
                                                        <input
                                                            className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                                            id="hasta"
                                                            name='hasta'
                                                            type='text'
                                                            placeholder={'Termino de contrato'}
                                                            value={dayjs(values.hasta).format('MMM. DD, YYYY')}
                                                            disabled={true}
                                                        />
                                                        <label htmlFor='hasta' className='text-gray-700'>Termino </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'row'}>
                                                <div className="col-md-5">
                                                    {
                                                        select.valor === "EF" ? (
                                                            <>
                                                                <Cajas formik={formik} ></Cajas>
                                                                <ErrorMessage name={'id_caja'}></ErrorMessage>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Banco formik={formik}></Banco>
                                                                <ErrorMessage name={'banco'}></ErrorMessage>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                                <InputsPago select={select} formik={formik}></InputsPago>
                                            </div>
                                            <div className="">
                                                <div className="table-responsive border-bottom">
                                                    <table className="table mb-3">
                                                        <tbody>
                                                        <tr className="fs-5 text-end text-uppercase">
                                                            <td className="d-flex align-items-center pt-0">
                                                                <i className="bi bi-gear-fill text-danger fs-2 me-2"></i>
                                                                Costo de paquete
                                                            </td>
                                                            <td className="fw-bold fs-6 text-gray-800 pt-0">$ {contrato.costo_paquete}.00</td>
                                                        </tr>
                                                        <tr className="fs-5 text-end text-uppercase">
                                                            <td className="d-flex align-items-center pt-0">
                                                                <i className="bi bi-gear-fill text-primary fs-2 me-2"></i>
                                                                Complementos
                                                            </td>
                                                            <td className="fw-bold fs-6 text-gray-800 pt-0">$ {contrato.costo_addons}.00</td>
                                                        </tr>
                                                        <tr className="fs-5 text-end text-uppercase">
                                                            <td className="d-flex align-items-center pt-0">
                                                                <i className="bi bi-gear-fill text-warning fs-2 me-2"></i>
                                                                Saldo anterior
                                                            </td>
                                                            <TitleTooltip title={contrato.saldo > 0 ? "Saldo a favor del cliente" : "Deuda anterior"} placement={'right'}>
                                                                <td className="fw-bold fs-6 text-gray-800 pt-0">$ {contrato.saldo}.00</td>
                                                            </TitleTooltip>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-8 mt-7">
                                                        <div className="form-floating mb-7">
                                                            <input type="text"
                                                                   className="form-control form-control-solid text-uppercase"
                                                                   id="cupon"
                                                                   name="cupon"
                                                                   placeholder="Cupon"
                                                                   value={values.cupon}
                                                                   onChange={formik.handleChange}
                                                                   onBlur={formik.handleBlur}
                                                            />
                                                            <label htmlFor="cupon" className={"text-gray-700"}>Cupón</label>
                                                        </div>
                                                        <div className="form-floating">
                                                        <textarea type="text"
                                                                  style={{resize : 'none', height : '5rem'}}
                                                                  className="form-control form-control-solid text-uppercase"
                                                                  id="observaciones"
                                                                  name="observaciones"
                                                                  placeholder="Nota"
                                                                  value={values.observaciones}
                                                                  onChange={formik.handleChange}
                                                                  onBlur={formik.handleBlur}
                                                        >
                                                        </textarea>
                                                            <label htmlFor="observaciones" className={"text-gray-700"}>Comentario / Nota</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="d-flex justify-content-end">
                                                            <div className="">
                                                                <ErrorMessage name={'ajuste'}></ErrorMessage>
                                                                <div className="d-flex flex-stack mb-3">
                                                                    <div className="form-check form-switch form-check-reverse" style={{display : 'contents'}} >
                                                                        <label htmlFor={'ajuste-switch'} className="fw-bold text-gray-700 fs-5 text-end me-2">Ajuste</label>
                                                                        <input id={'ajuste-switch'} className="form-check-input w-25px h-15px m-0" type="checkbox" checked={switchAjuste} onChange={(e) => setSwitchAjuste(e.target.checked)} />
                                                                    </div>
                                                                    <input
                                                                        type={'text'}
                                                                        className={"form-control form-control-solid form-control-sm ms-8"}
                                                                        id={'ajuste'}
                                                                        name={'ajuste'}
                                                                        value={values.ajuste}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        disabled={!switchAjuste}
                                                                    />
                                                                </div>
                                                                <div className="d-flex flex-stack mb-3">
                                                                    <div className="fw-bold text-gray-700 fs-5 text-end">Subtotal</div>
                                                                    <div className="text-end fw-bold fs-6 text-gray-800">$ {values.subtotal}.00</div>
                                                                </div>
                                                                <div className="d-flex flex-stack mb-3">
                                                                    <div className="form-check form-switch form-check-reverse d-flex align-items-center">
                                                                        <label htmlFor={'factura-switch'} className="fw-bold text-gray-700 fs-5 text-end me-2">Factura</label>
                                                                        <input id={'factura-switch'} className="form-check-input w-25px h-15px m-0" type="checkbox" checked={values.factura} onChange={(e) => setFieldValue('factura',e.target.checked)}/>
                                                                    </div>
                                                                    <div className="text-end fw-bold fs-6 text-gray-800">$ {(facSwitch)}.00</div>
                                                                </div>
                                                                <div className="d-flex flex-stack">
                                                                    <div className="fw-bold text-gray-700 fs-6 text-end">Total</div>
                                                                    <div className="text-end fw-bold fs-6 text-gray-800">$ {values.total}.00</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </FormikProvider>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
/**
 * COMPONENTE : InputsPago ( Retorna los respectivos inputs de cada forma de pago )
 * @param select
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
function InputsPago({select, formik}) {
    switch (select.valor) {
        case "TR":
            return (
                <>
                    <div className="col-md-7">
                        <div className="form-floating ">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="concepto"
                                name="concepto"
                                value={formik.values.concepto}
                                placeholder="Concepto / Referencia"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="concepto" className={"text-gray-700"}>Concepto / Referencia</label>
                        </div>
                        <ErrorMessage name={'concepto'}></ErrorMessage>
                    </div>
                    <div className="col-12">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="cuentahabiente"
                                name="cuentahabiente"
                                value={formik.values.cuentahabiente}
                                placeholder="Cuentahabiente"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="cuentahabiente" className={"text-gray-700"}>Nombre de cuentahabiente</label>
                        </div>
                        <ErrorMessage name={'cuentahabiente'}></ErrorMessage>
                    </div>
                </>
            );
        case "DE":
            return (
                <>
                    <div className="col-md-7">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="autorizacion"
                                name="autorizacion"
                                value={formik.values.autorizacion}
                                placeholder="Número de autorización"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="autorizacion" className={"text-gray-700"}>No. de autorización</label>
                        </div>
                        <ErrorMessage name={'autorizacion'}></ErrorMessage>
                    </div>
                    <div className="col-md-12">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="referencia"
                                name="referencia"
                                value={formik.values.referencia}
                                placeholder="Referencia"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="referencia" className={"text-gray-700"}>Referencia</label>
                            <ErrorMessage name={'referencia'}></ErrorMessage>
                        </div>
                    </div>
                </>
            );
        case "CO":
            return (
                <>
                    <div className="col-md-7">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="autorizacion"
                                name="autorizacion"
                                value={formik.values.autorizacion}
                                placeholder="Número de autorizacion"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="autorizacion" className={"text-gray-700"}>No. de autorización</label>
                        </div>
                        <ErrorMessage name={'autorizacion'}></ErrorMessage>
                    </div>
                </>
            );
        case "TE":
            return (
                <>
                    <div className="col-md-6">
                        <Tarjeta formik={formik}></Tarjeta>
                        <ErrorMessage name={'tarjeta'}></ErrorMessage>
                    </div>
                </>
            );
        case "CH":
            return (
                <>
                    <div className="col-md-7">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control form-control-solid text-uppercase"
                                id="sucursal"
                                name="sucursal"
                                value={formik.values.sucursal}
                                placeholder="Número de sucursal"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="sucursal" className={"text-gray-700"}>No. de sucursal</label>
                        </div>
                        <ErrorMessage name={'sucursal'}></ErrorMessage>
                    </div>
                </>
            );
        default :
            return <></>;
    }
}
